import { render, staticRenderFns } from "./CooperateConsult.vue?vue&type=template&id=3ce184ec&scoped=true&"
import script from "./CooperateConsult.vue?vue&type=script&lang=js&"
export * from "./CooperateConsult.vue?vue&type=script&lang=js&"
import style0 from "./CooperateConsult.vue?vue&type=style&index=0&id=3ce184ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce184ec",
  null
  
)

export default component.exports